import "./index.css";

import React from "react";
import ReactDOM from "react-dom";

import { ConfigProvider } from "antd";
import { Provider } from "react-redux";

import App from "./App";
import ThemeProvider from "./context/ThemeProvider";
import * as serviceWorker from "./serviceWorker";
import { store } from "./store";

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
